import React, { memo } from "react";
import { Main } from "Shared/PageLayout";
import { SMALL } from "Shared/breakpoints";
import ContentArea from "Shared/Partials/PropertyTypes/ContentArea";
import classnames from "classnames";
import * as styles from "./base.scss";
const SocialMediaLinks = (props) => {
    return (React.createElement("ul", { className: styles.socialMediaLinks },
        React.createElement("li", null, props.footer.facebookIcon && (React.createElement("a", { href: props.footer.facebookUrl, target: "_blank" },
            React.createElement("img", { src: props.footer.facebookIcon })))),
        React.createElement("li", null, props.footer.instagramIcon && (React.createElement("a", { href: props.footer.instagramUrl, target: "_blank" },
            React.createElement("img", { src: props.footer.instagramIcon })))),
        React.createElement("li", null, props.footer.twitterIcon && (React.createElement("a", { href: props.footer.twitterUrl, target: "_blank" },
            React.createElement("img", { src: props.footer.twitterIcon })))),
        React.createElement("li", null, props.footer.youtubeIcon && (React.createElement("a", { href: props.footer.youTubeUrl, target: "_blank" },
            React.createElement("img", { src: props.footer.youtubeIcon }))))));
};
const hasSocialMediaBlocks = (props) => {
    const socialMediaBlocks = !!props.footer.socialMediaArea &&
        props.footer.socialMediaArea;
    const hasSocialMediaBlocks = !!socialMediaBlocks && socialMediaBlocks.items.length ? true : false;
    return hasSocialMediaBlocks;
};
const AboveFooter = memo((props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classnames(styles.lightBackground) },
            React.createElement(Main, { className: classnames(styles.lightBackground, styles.fixPadding) },
                React.createElement(ContentArea, Object.assign({}, props.footer.topFooterLinksArea, { className: styles.aboveFooterLinks })),
                hasSocialMediaBlocks(props) ? (React.createElement(ContentArea, Object.assign({}, props.footer.socialMediaArea, { className: styles.socialMediaLinks }))) : (React.createElement(SocialMediaLinks, Object.assign({}, props))),
                React.createElement(ContentArea, Object.assign({}, props.footer.newsletterFormArea, { className: styles.removeMargin })))),
        React.createElement("div", { className: styles.footerLinksContainer },
            React.createElement(Main, { className: classnames(styles.lightBackground, styles.footerLinks, styles.removeMargin, { [styles.fixPadding]: props.currentBreakpoint > SMALL }) },
                React.createElement(ContentArea, Object.assign({}, props.footer.footerNavigationLinksArea, { className: styles.removeMargin }))))));
});
export default AboveFooter;
